import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { StateService } from 'src/app/services/state.service';
import { User } from 'src/app/interfaces/user';

@Component({
  selector: 'app-user-forms',
  templateUrl: './user-forms.component.html',
  styleUrls: ['./user-forms.component.scss'],
})
export class UserFormsComponent implements OnInit {
  activeTab: string = 'Introduccion';
  user?: User;
  userId!: string;

  constructor(
    private stateService: StateService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.user = this.stateService.selectedUser;

    this.route.paramMap.subscribe((params) => {
      if (!params.get('userId')) return;

      this.userId = params.get('userId') as string;
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  redirectToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
